<template>
  <article :class="[{ 'margin-bottom-5xl': !isLast }]">
    <ais-instant-search
      ref="instantSearch"
      :index-name="index"
      :insights-client="insightsClient"
      :middlewares="middlewares"
      :search-client="searchClient"
      :search-parameters="{ clickAnalytics: true }"
    >
      <ais-configure
        ref="configure"
        :distinct="true"
        :facet-filters.camel="facetFilters"
        :hits-per-page.camel="pageSize"
        :page="page"
      />

      <ais-stats>
        <div class="row roomy align-middle align-between margin-bottom-xl">
          <div class="column-12 tablet:column-8 margin-bottom-sm tablet:margin-bottom-0">
            <h3>{{ familyStyleLabel }}</h3>
          </div>
          <div
            v-if="visualTags"
            class="column-12 tablet:column-4 tablet:text-right display-flex flex-items-center tablet:flex-content-end"
            style="gap: var(--spacing-sm)"
          >
            <span
              :aria-label="`Icon Types in ${familyStyleLabel}`"
              data-balloon-pos="up"
            >
              <font-awesome-icon
                :icon="$v6.solid.faTag"
                class="margin-right-3xs"
              />
            </span>
            <site-link
              v-for="(visualTag, idx) in visualTags"
              :key="idx"
              :to="$search({ iconTypes: visualTag })"
              class="size-sm"
              style="--link-color: var(--theme-action-primary-dk); --link-hover-color: var(--theme-action-primary)"
            >
              {{ startCaseString(visualTag) }}
            </site-link>
          </div>
        </div>
      </ais-stats>

      <icon-list
        ref="iconList"
        :selected-family="selectedFamily"
        :selected-style="selectedStyle"
        :is-pro-user="isProUser"
        :selected-icon-id="selectedIconId"
        :version="version"
        :search-field-focus="searchFieldFocus"
        results-view="compact"
        @toggleIcon="toggleIcon"
        @closeIcon="closeIcon"
      >
      </icon-list>
    </ais-instant-search>
  </article>
</template>

<script>
  import { startCase } from 'lodash'
  import algoliasearch from 'algoliasearch/lite'
  import { aa, createInsightsMiddleware } from 'app/views/search/insightUtils.js'
  import { IconsMixins } from 'app/views/icons/components/icons/mixins.js'
  import IconList from './IconList'

  export default {
    name: 'PackIconList',

    components: {
      IconList
    },

    mixins: [IconsMixins],

    props: {
      index: {
        type: String,
        required: true
      },
      isLast: {
        type: Boolean,
        default: false
      },
      isProUser: {
        type: Boolean,
        required: true
      },
      selectedFamily: {
        type: String,
        required: true
      },
      selectedStyle: {
        type: String,
        required: true
      },
      visualTags: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        insightsClient: aa,
        isLoading: false,
        middlewares: [createInsightsMiddleware()],
        pageSize: 23,
        page: 0,
        searchClient: algoliasearch(FONTAWESOME.ALGOLIA_APPLICATION_ID, FONTAWESOME.ALGOLIA_SEARCH_API_KEY),
        searchFieldFocus: false,
        selectedIcon: null,
        selectedIconId: null
      }
    },

    computed: {
      facetFilters() {
        const filters = []
        filters.push('type:icon')

        // Algolia index has brands set as a family
        if (this.selectedStyle == 'brands') {
          filters.push('family:brands')
        } else {
          filters.push(`family:${this.selectedFamily}`)
          filters.push(`style:${this.selectedStyle}`)
        }
        return filters
      },

      familyStyleLabel() {
        return `${startCase(this.selectedFamily)} ${startCase(this.selectedStyle)}`
      },

      version() {
        return this.$releases.active.versionParts.major
      }
    },

    beforeMount() {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 300)
    },

    async created() {
      window.addEventListener('popstate', this.closeIcon)
    },

    destroyed() {
      window.removeEventListener('popstate', this.closeIcon)
    },

    methods: {
      closeIcon() {
        this.$emit('closeIcon')
      },

      startCaseString(string) {
        return startCase(string)
      },

      shuffleAndLoadNextPage() {
        this.page = this.page + 1
      },

      toggleIcon(icon, elementTag, objectId) {
        this.$emit('toggleIcon', icon, elementTag)
      }
    }
  }
</script>
